import { withIcon } from "../Icon"

export const IconProfile = withIcon(
  '<path stroke="currentColor" fill="none" stroke-width="1.7" d="M12 9.8c1.933 0 3.5-1.522 3.5-3.4S13.933 3 12 3 8.5 4.522 8.5 6.4s1.567 3.4 3.5 3.4Z"/><path stroke="currentColor" fill="none" stroke-width="1.5" d="M19 16.175C19 18.287 19 20 12 20s-7-1.713-7-3.825 3.134-3.825 7-3.825 7 1.713 7 3.825Z"/>',
)
